import { launchDetailsQueryOptions } from '@/hooks/queries/useLaunches'
import { reportDetailsQueryOptions } from '@/hooks/queries/useReports'
import { queryClient } from '@/main'
import { getLocale } from '@/stores/i18n'
import i18n from 'i18next'

export async function getReportBreadcrumb(reportId: string) {
  const fallback = `${i18n.t('crumb.prefix', { ns: 'reports', lng: getLocale() })} #${reportId}`

  try {
    const report = await queryClient.ensureQueryData(reportDetailsQueryOptions(reportId))

    if (report?.name) return report.name

    return fallback
  } catch {
    return fallback
  }
}

export async function getLaunchBreadcrumb(launchId: string) {
  const fallback = `${i18n.t('crumb.prefix', { ns: 'launch', lng: getLocale() })} #${launchId}`

  try {
    const launch = await queryClient.ensureQueryData(launchDetailsQueryOptions(launchId))

    if (launch?.launchName) return launch?.launchName

    return fallback
  } catch {
    return fallback
  }
}
